import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "add-attachments-hos-pal",
  class: "px-2 px-lg-5 py-2 rounded-lg border shadow mb-1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", null, "Add Attachment", -1 /* HOISTED */)
const _hoisted_3 = { class: "py-4 d-flex flex-column gap-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-12 col-md-4 offset-md-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" File "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "upload-document"
}
const _hoisted_8 = {
  type: "button",
  class: "btn btn-primary border border-primary"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Choose File ")
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback d-block",
  id: "validation-feedback-1"
}
const _hoisted_11 = {
  key: 1,
  class: "input-border p-2 bg-white"
}
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file text-primary animated flash infinite slower font-size-md blinking-content" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary ms-2" }, "Loading File...", -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "au-target file-icon far fa-file fa-file-image font-size-md me-1",
  "au-target-id": "1814"
}, null, -1 /* HOISTED */)
const _hoisted_18 = {
  class: "au-target",
  href: "javascript:void(0);"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "form-group col-12 col-md-4 is-invalid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Document Type "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback d-block",
  id: "validation-feedback-2"
}
const _hoisted_23 = {
  key: 0,
  class: "d-flex justify-content-center mt-2 p-2"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_FormSection, {
      "full-height": false,
      "show-product-pill": false,
      "application-id": _ctx.visitDetails.Application
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (!_ctx.fileDetails && !_ctx.uploading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("input", {
                        type: "file",
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFilesChanged($event))),
                        class: "file-input"
                      }, null, 32 /* HYDRATE_EVENTS */)
                    ]),
                    (_ctx.fileUploadErrorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.fileUploadErrorMessage), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_ctx.uploading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createCommentVNode("anchor"),
                          _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.fileDetails.name), 1 /* TEXT */),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn table-btn btn-outline-danger ml-auto au-target",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeAllFiles())),
                            disabled: _ctx.isSaving
                          }, " Remove ", 8 /* PROPS */, _hoisted_19)
                        ]))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_TypeaheadInput, {
                placeholder: "Start Typing...",
                data: _ctx.searchedTypes,
                value: _ctx.selectedUploadType,
                onValueChanged: _cache[2] || (_cache[2] = (newValue) => _ctx.updateTypeId(newValue.value)),
                onBlurredInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.fileDetails.uploadTypeId.$touch())),
                disabled: _ctx.uploading || _ctx.isSaving,
                showAllByDefault: true,
                openOnFocus: true
              }, null, 8 /* PROPS */, ["data", "value", "disabled"]),
              (_ctx.v$.fileDetails.uploadTypeId.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Document Type is required. "))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _hoisted_26))
            : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveAttachment()))
                }, "Save Attachment"),
                _createElementVNode("button", {
                  type: "button",
                  class: "ms-1 btn btn-md btn-outline-secondary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleUploadFile()))
                }, " Cancel ")
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}